var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1657 4.23431C10.4781 4.54673 10.4781 5.05327 10.1657 5.36569L7.53135 8L10.1657 10.6343C10.4781 10.9467 10.4781 11.4533 10.1657 11.7657C9.85324 12.0781 9.34671 12.0781 9.03429 11.7657L5.83429 8.56569C5.52187 8.25327 5.52187 7.74673 5.83429 7.43431L9.03429 4.23431C9.34671 3.9219 9.85324 3.9219 10.1657 4.23431Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarArrowLeft);
export default __webpack_public_path__ + "static/media/sidebar-arrow-left.eccf9efda8855b238b12a228a87e294c.svg";
export { ForwardRef as ReactComponent };